import React from 'react';
import { Dialog, DialogContent, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';

const ErrorValidationDialog = ({ open, onClose, errors = [] }) => {
  const errorCount = errors.length;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          overflow: 'hidden',
          maxHeight: '80vh',
        }
      }}
    >
      {/* Red Header */}
      <Box
        sx={{
          backgroundColor: '#dc4c4c',
          color: 'white',
          padding: '16px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
          {errorCount} Error{errorCount !== 1 ? 's' : ''} Detected
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            padding: '4px',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content Area */}
      <DialogContent 
        sx={{ 
          padding: '24px',
          maxHeight: 'calc(80vh - 80px)',
          overflowY: 'auto',
        }}
      >
        {/* Introductory Text */}
        <Typography 
          variant="body1" 
          sx={{ 
            marginBottom: '24px',
            fontSize: '16px',
            lineHeight: '1.5',
            color: '#333',
          }}
        >
          Please correct the errors listed below before submitting. 监测到可能的错误。请在提交前修正下列错误。
        </Typography>

        {/* Error List */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {errors.map((error, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                padding: '0',
              }}
            >
              {/* Warning Icon */}
              <WarningIcon 
                sx={{ 
                  color: '#dc4c4c',
                  fontSize: '20px',
                  marginTop: '2px',
                  flexShrink: 0,
                }}
              />
              
              {/* Error Text */}
              <Typography
                variant="body2"
                sx={{
                  fontSize: '14px',
                  lineHeight: '1.6',
                  color: '#333',
                  whiteSpace: 'pre-wrap',
                  flex: 1,
                }}
              >
                {error}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorValidationDialog;
